
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/integrations/tailwindcss/tailwindcss-components",
      function () {
        return require("private-next-pages/material-ui/integrations/tailwindcss/tailwindcss-components.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/integrations/tailwindcss/tailwindcss-components"])
      });
    }
  